"use strict";

exports.__esModule = true;
exports.CardSection = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardSection = function CardSection(_ref) {
  var _classnames;

  var className = _ref.className,
      header = _ref.header,
      footer = _ref.footer,
      actions = _ref.actions,
      empty = _ref.empty,
      props = _objectWithoutProperties(_ref, ["className", "header", "footer", "actions", "empty"]);

  var prefixCls = "card__section";

  /*eslint-disable no-nested-ternary */
  var type = header ? "header" : footer ? "footer" : actions ? "actions" : empty ? "empty" : null;
  /*eslint-enable no-nested-ternary */

  var componentCls = (0, _classnames3.default)(prefixCls, (_classnames = {}, _classnames[prefixCls + "--" + type] = type, _classnames), className);

  return _react2.default.createElement("div", _extends({ className: componentCls }, props));
};

exports.CardSection = CardSection;
CardSection.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  header: _propTypes2.default.bool,
  footer: _propTypes2.default.bool,
  actions: _propTypes2.default.bool,
  empty: _propTypes2.default.bool
} : {};

exports.default = CardSection;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/card/card-section.js
// module id = 1417
// module chunks = 249